import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
  animate?: boolean;
}

export const Card: React.FC<CardProps> = ({ className = '', children, animate = false, ...props }) => {
  return (
    <div
      className={`rounded-lg shadow-md bg-white ${animate ? 'transition-all duration-300 hover:-translate-y-1 hover:shadow-lg' : ''} ${className || ''}`}
      {...props}
    >
      {children}
    </div>
  );
};
